import { MeetingListSearchQuery, PaginationQuery } from "@api";

import { initinalPaginationQuery } from "./initialState";
import { meetingsState } from "./types";

const setScrollPosition = (state: meetingsState, newScrollPosition: number): meetingsState => {
	const newState: meetingsState = {
		...state,
		scrollPosition: newScrollPosition,
	};

	return newState;
};

const setSearchQuery = (state: meetingsState, newSearchQuery: MeetingListSearchQuery): meetingsState => {
	const stateWithResettedPageSettings = resetPageSettings(state);
	const newState: meetingsState = {
		...stateWithResettedPageSettings,
		query: newSearchQuery,
	};

	return newState;
};

const setPageNumber = (state: meetingsState, newCurrentPage: number): meetingsState => {
	const newState: meetingsState = {
		...state,
		paginationQuery: new PaginationQuery({
			...state.paginationQuery,
			currentPage: newCurrentPage,
		}),
	};

	return newState;
};

const setShowOrganizations = (state: meetingsState, newShowOrganizations: boolean): meetingsState => {
	const newState: meetingsState = {
		...state,
		showOrganizations: newShowOrganizations,
	};

	return newState;
};


const resetPageSettings = (state: meetingsState): meetingsState => {
	const newState: meetingsState = {
		...state,
		paginationQuery: initinalPaginationQuery,
	};

	return newState;
};

const actions = {
	setScrollPosition,
	resetPageSettings,
	setSearchQuery,
	setPageNumber,
	setShowOrganizations,
};

export {actions};